import { c as _c } from "react-compiler-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { CardWrapper, CardSection } from 'foundations-components/transitional/components/Card';
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import { getParticipantInitials } from 'recording-review-components-lib/utils/mediaParticipantListUtils';
import { useActiveLocale } from '../locale/LocaleContext';
import { formatMeetingDateTime } from '../locale/formatMeetingDateTime';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PublicMeetingDetails = t0 => {
  const $ = _c(24);
  const {
    details
  } = t0;
  const locale = useActiveLocale();
  let t1;
  if ($[0] !== details.callSource || $[1] !== details.endTime || $[2] !== details.notetakerLabel || $[3] !== details.startTime || $[4] !== locale) {
    t1 = details.startTime !== null ? formatMeetingDateTime({
      startTime: details.startTime,
      endTime: details.endTime,
      callSource: details.callSource,
      notetakerLabel: details.notetakerLabel,
      locale
    }) : null;
    $[0] = details.callSource;
    $[1] = details.endTime;
    $[2] = details.notetakerLabel;
    $[3] = details.startTime;
    $[4] = locale;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const dateTimeString = t1;
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = /*#__PURE__*/_jsx(Text, {
      typography: "heading-300",
      marginBlockEnd: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "external-sharing-components.meetingDetails.heading"
      })
    });
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== details.title) {
    t3 = /*#__PURE__*/_jsx(Text, {
      typography: "heading-200",
      marginBlockEnd: "100",
      children: details.title
    });
    $[7] = details.title;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== dateTimeString) {
    t4 = dateTimeString && /*#__PURE__*/_jsx(Text, {
      typography: "body-100",
      color: "text-core-subtle",
      marginBlockEnd: "200",
      children: dateTimeString
    });
    $[9] = dateTimeString;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== details.participants.length) {
    t5 = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "external-sharing-components.meetingDetails.participants.heading",
      options: {
        count: details.participants.length
      }
    });
    $[11] = details.participants.length;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== details.participants) {
    t6 = details.participants.map(_temp);
    $[13] = details.participants;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t6) {
    t7 = /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      gap: "100",
      children: t6
    });
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t5 || $[18] !== t7) {
    t8 = /*#__PURE__*/_jsx(AccordionItem, {
      defaultOpen: true,
      titleTagName: "span",
      flush: true,
      title: t5,
      children: t7
    });
    $[17] = t5;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t3 || $[21] !== t4 || $[22] !== t8) {
    t9 = /*#__PURE__*/_jsx(CardWrapper, {
      children: /*#__PURE__*/_jsxs(CardSection, {
        children: [t2, t3, t4, t8]
      })
    });
    $[20] = t3;
    $[21] = t4;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
};
function _temp(p, index) {
  var _p$email;
  const initials = getParticipantInitials(p.name);
  return /*#__PURE__*/_jsxs(Flex, {
    gap: "200",
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "full",
      backgroundColor: "fill-surface-recessed",
      inlineSize: "600",
      blockSize: "600",
      children: /*#__PURE__*/_jsx(Text, {
        typography: "detail-100",
        color: "text-core-default",
        children: initials
      })
    }), /*#__PURE__*/_jsx(Text, {
      typography: "body-100",
      children: p.isOrganizer ? unescapedText("external-sharing-components.meetingDetails.participants.organizerWithSuffix", {
        name: p.name
      }) : p.name
    })]
  }, `${p.name}-${(_p$email = p.email) !== null && _p$email !== void 0 ? _p$email : index}`);
}